"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildInstantChain = exports.instantFns = void 0;
const ES = __importStar(require("../ecmascript"));
const durationFns_1 = require("./durationFns");
const zonedDateTimeFns_1 = require("./zonedDateTimeFns");
const DISALLOWED_UNITS = ['year', 'month', 'week', 'day'];
const MAX_DIFFERENCE_INCREMENTS = {
    hour: 24,
    minute: 60,
    second: 60,
    millisecond: 1000,
    microsecond: 1000,
    nanosecond: 1000
};
exports.instantFns = {
    now() {
        return ES.CreateTemporalInstant(ES.SystemUTCEpochMilliSeconds());
    },
    fromEpochMilliseconds(epochMilliseconds) {
        if (arguments.length < 1) {
            throw new TypeError('missing argument: epochNanoseconds is required');
        }
        const ms = epochMilliseconds;
        ES.ValidateEpochMilliseconds(ms);
        return ES.CreateTemporalInstant(ms);
    },
    isValid(instant) {
        return ES.IsTemporalInstant(instant);
    },
    assertIsValid(instant) {
        if (!ES.IsTemporalInstant(instant))
            throw new TypeError('invalid receiver');
    },
    getEpochSeconds(instant) {
        if (!ES.IsTemporalInstant(instant))
            throw new TypeError('invalid receiver');
        const value = ES.GetInstantSlots(instant).epochMilliseconds;
        return Math.floor(value / 1e3);
    },
    getEpochMilliseconds(instant) {
        if (!ES.IsTemporalInstant(instant))
            throw new TypeError('invalid receiver');
        const value = ES.GetInstantSlots(instant).epochMilliseconds;
        return value;
    },
    add(instant, temporalDurationLike) {
        if (!ES.IsTemporalInstant(instant))
            throw new TypeError('invalid receiver');
        const { hours, minutes, seconds, milliseconds } = ES.ToLimitedTemporalDuration(temporalDurationLike, [
            'years',
            'months',
            'weeks',
            'days'
        ]);
        const ms = ES.AddInstant(ES.GetInstantSlots(instant).epochMilliseconds, hours, minutes, seconds, milliseconds);
        return ES.CreateTemporalInstant(ms);
    },
    subtract(instant, temporalDurationLike) {
        if (!ES.IsTemporalInstant(instant))
            throw new TypeError('invalid receiver');
        const { hours, minutes, seconds, milliseconds } = ES.ToLimitedTemporalDuration(temporalDurationLike, [
            'years',
            'months',
            'weeks',
            'days'
        ]);
        const ns = ES.AddInstant(ES.GetInstantSlots(instant).epochMilliseconds, -hours, -minutes, -seconds, -milliseconds);
        return ES.CreateTemporalInstant(ns);
    },
    until(from, until, options = {}) {
        if (!ES.IsTemporalInstant(from))
            throw new TypeError('invalid receiver');
        until = ES.ToTemporalInstant(until);
        options = ES.GetOptionsObject(options);
        const smallestUnit = ES.ToSmallestTemporalUnit(options, 'millisecond', DISALLOWED_UNITS);
        const defaultLargestUnit = ES.LargerOfTwoTemporalUnits('second', smallestUnit);
        const largestUnit = ES.ToLargestTemporalUnit(options, 'auto', DISALLOWED_UNITS, defaultLargestUnit);
        ES.ValidateTemporalUnitRange(largestUnit, smallestUnit);
        const roundingMode = ES.ToTemporalRoundingMode(options, 'trunc');
        const roundingIncrement = ES.ToTemporalRoundingIncrement(options, MAX_DIFFERENCE_INCREMENTS[smallestUnit], false);
        const oneMs = ES.GetInstantSlots(from).epochMilliseconds;
        const twoMs = ES.GetInstantSlots(until).epochMilliseconds;
        let { seconds, milliseconds } = ES.DifferenceInstant(oneMs, twoMs, roundingIncrement, smallestUnit, roundingMode);
        let hours, minutes;
        ({ hours, minutes, seconds, milliseconds } = ES.BalanceDuration(0, 0, 0, seconds, milliseconds, largestUnit));
        return ES.CreateTemporalDuration(0, 0, 0, 0, hours, minutes, seconds, milliseconds);
    },
    since(to, since, options = {}) {
        if (!ES.IsTemporalInstant(to))
            throw new TypeError('invalid receiver');
        since = ES.ToTemporalInstant(since);
        options = ES.GetOptionsObject(options);
        const smallestUnit = ES.ToSmallestTemporalUnit(options, 'millisecond', DISALLOWED_UNITS);
        const defaultLargestUnit = ES.LargerOfTwoTemporalUnits('second', smallestUnit);
        const largestUnit = ES.ToLargestTemporalUnit(options, 'auto', DISALLOWED_UNITS, defaultLargestUnit);
        ES.ValidateTemporalUnitRange(largestUnit, smallestUnit);
        const roundingMode = ES.ToTemporalRoundingMode(options, 'trunc');
        const roundingIncrement = ES.ToTemporalRoundingIncrement(options, MAX_DIFFERENCE_INCREMENTS[smallestUnit], false);
        const oneMs = ES.GetInstantSlots(to).epochMilliseconds;
        const twoMs = ES.GetInstantSlots(since).epochMilliseconds;
        let { seconds, milliseconds } = ES.DifferenceInstant(oneMs, twoMs, roundingIncrement, smallestUnit, roundingMode);
        let hours, minutes;
        ({ hours, minutes, seconds, milliseconds } = ES.BalanceDuration(0, 0, 0, seconds, milliseconds, largestUnit));
        return ES.CreateTemporalDuration(0, 0, 0, 0, hours, minutes, seconds, milliseconds);
    },
    round(instant, options) {
        if (!ES.IsTemporalInstant(instant))
            throw new TypeError('invalid receiver');
        if (options === undefined)
            throw new TypeError('options parameter is required');
        options = ES.GetOptionsObject(options);
        const smallestUnit = ES.ToSmallestTemporalUnit(options, undefined, DISALLOWED_UNITS);
        if (smallestUnit === undefined)
            throw new RangeError('smallestUnit is required');
        const roundingMode = ES.ToTemporalRoundingMode(options, 'halfExpand');
        const maximumIncrements = {
            hour: 24,
            minute: 1440,
            second: 86400,
            millisecond: 86400e3,
            microsecond: 86400e6,
            nanosecond: 86400e9
        };
        const roundingIncrement = ES.ToTemporalRoundingIncrement(options, maximumIncrements[smallestUnit], true);
        const ms = ES.GetInstantSlots(instant).epochMilliseconds;
        const roundedNs = ES.RoundInstant(ms, roundingIncrement, smallestUnit, roundingMode);
        return ES.CreateTemporalInstant(roundedNs);
    },
    equals(instant, other) {
        if (!ES.IsTemporalInstant(instant))
            throw new TypeError('invalid receiver');
        if (!ES.IsTemporalInstant(other))
            throw new TypeError('invalid receiver');
        const one = ES.GetInstantSlots(instant).epochMilliseconds;
        const two = ES.GetInstantSlots(other).epochMilliseconds;
        return one === two;
    },
    isEqual(instant, other) {
        return exports.instantFns.equals(instant, other);
    },
    isBefore(instant, other) {
        if (!ES.IsTemporalInstant(instant))
            throw new TypeError('invalid receiver');
        if (!ES.IsTemporalInstant(other))
            throw new TypeError('invalid receiver');
        const one = ES.GetInstantSlots(instant).epochMilliseconds;
        const two = ES.GetInstantSlots(other).epochMilliseconds;
        return one < two;
    },
    isAfter(instant, other) {
        if (!ES.IsTemporalInstant(instant))
            throw new TypeError('invalid receiver');
        if (!ES.IsTemporalInstant(other))
            throw new TypeError('invalid receiver');
        const one = ES.GetInstantSlots(instant).epochMilliseconds;
        const two = ES.GetInstantSlots(other).epochMilliseconds;
        return one > two;
    },
    isEqualOrBefore(instant, other) {
        return exports.instantFns.isEqual(instant, other) || exports.instantFns.isBefore(instant, other);
    },
    isEqualOrAfter(instant, other) {
        return exports.instantFns.isEqual(instant, other) || exports.instantFns.isAfter(instant, other);
    },
    toZonedDateTime(instant, timeZone) {
        if (!ES.IsTemporalInstant(instant))
            throw new TypeError('invalid receiver');
        timeZone = ES.ToTemporalTimeZone(timeZone);
        return ES.CreateTemporalZonedDateTime(ES.GetInstantSlots(instant).epochMilliseconds, timeZone);
    },
    toJsDate(instant) {
        return new Date(instant);
    },
    fromEpochSeconds(epochSeconds) {
        epochSeconds = ES.ToNumber(epochSeconds);
        const epochNanoseconds = epochSeconds * 1e3;
        ES.ValidateEpochMilliseconds(epochNanoseconds);
        return ES.CreateTemporalInstant(epochNanoseconds);
    },
    from(item) {
        if (ES.IsTemporalInstant(item)) {
            return ES.CreateTemporalInstant(ES.GetInstantSlots(item).epochMilliseconds);
        }
        return ES.ToTemporalInstant(item);
    },
    compare(one, two) {
        if (!ES.IsTemporalInstant(one))
            throw new TypeError('invalid receiver');
        if (!ES.IsTemporalInstant(two))
            throw new TypeError('invalid receiver');
        const oneMs = ES.GetInstantSlots(one).epochMilliseconds;
        const twoMs = ES.GetInstantSlots(two).epochMilliseconds;
        if (oneMs < twoMs)
            return -1;
        if (oneMs > twoMs)
            return 1;
        return 0;
    },
    chain: buildInstantChain
};
function buildInstantChain(instant) {
    return {
        value() {
            return instant;
        },
        getEpochSeconds() {
            return ES.buildChain(exports.instantFns.getEpochSeconds(instant));
        },
        getEpochMilliseconds() {
            return ES.buildChain(exports.instantFns.getEpochMilliseconds(instant));
        },
        add(temporalDurationLike) {
            return buildInstantChain(exports.instantFns.add(instant, temporalDurationLike));
        },
        subtract(temporalDurationLike) {
            return buildInstantChain(exports.instantFns.subtract(instant, temporalDurationLike));
        },
        until(until, options) {
            return durationFns_1.buildDurationChain(exports.instantFns.until(instant, until, options));
        },
        since(since, options) {
            return durationFns_1.buildDurationChain(exports.instantFns.since(instant, since, options));
        },
        round(options) {
            return buildInstantChain(exports.instantFns.round(instant, options));
        },
        equals(other) {
            return ES.buildChain(exports.instantFns.equals(instant, other));
        },
        isEqual(other) {
            return ES.buildChain(exports.instantFns.isEqual(instant, other));
        },
        isBefore(other) {
            return ES.buildChain(exports.instantFns.isBefore(instant, other));
        },
        isAfter(other) {
            return ES.buildChain(exports.instantFns.isAfter(instant, other));
        },
        isEqualOrBefore(other) {
            return ES.buildChain(exports.instantFns.isEqualOrBefore(instant, other));
        },
        isEqualOrAfter(other) {
            return ES.buildChain(exports.instantFns.isEqualOrAfter(instant, other));
        },
        toZonedDateTime(timeZone) {
            return zonedDateTimeFns_1.buildZonedDateTimeChain(exports.instantFns.toZonedDateTime(instant, timeZone));
        },
        toJsDate() {
            return ES.buildChain(new Date(instant));
        }
    };
}
exports.buildInstantChain = buildInstantChain;
